import React from "react";

export default function JS_Constructor() {
  return (
    <div className="tutorial-container">
      <h1>JS Constructor</h1>
      <p>
        This tutorial explains the concept of JS Constructor in JavaScript OOPs.
      </p>
    </div>
  );
}
